import {
  Dialog,
  DialogContainer,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Spinner,
} from "@dust-tt/sparkle";
// biome-ignore lint/correctness/noUnusedImports: ignored using `--suppress`
import React from "react";
import { useTranslation } from "react-i18next";

type DeleteConversationsDialogProps = {
  isOpen: boolean;
  isDeleting?: boolean;
  onClose: () => void;
  onDelete: () => void;
  type: "all" | "selection";
  selectedCount?: number;
};

export const DeleteConversationsDialog = ({
  isOpen,
  isDeleting,
  onClose,
  onDelete,
  type,
  selectedCount,
}: DeleteConversationsDialogProps) => {
  const { t } = useTranslation();
  const title =
    type === "all"
      ? t("conv.clearConversationHistoryTitle", "Clear conversation history")
      : t("conv.deleteConversationTitle", {
          defaultValue_one: "Delete conversation",
          defaultValue_other: "Delete conversations",
          count: selectedCount ?? 0,
        });

  const description =
    type === "all"
      ? t(
          "common.deleteAllConversationsConfirm",
          "Are you sure you want to delete ALL conversations?"
        )
      : t("common.deleteConversationsConfirm", {
          defaultValue_one:
            "Are you sure you want to delete {{count}} conversation?",
          defaultValue_other:
            "Are you sure you want to delete {{count}} conversations?",
          count: selectedCount ?? 0,
        });

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {isDeleting ? (
          <div className="flex justify-center py-8">
            <Spinner variant="dark" size="md" />
          </div>
        ) : (
          <>
            <DialogContainer>
              <b>
                {t(
                  "common.actionCannotBeUndone",
                  "This action cannot be undone."
                )}
              </b>
            </DialogContainer>
            <DialogFooter
              leftButtonProps={{
                label: t("conv.cancel", "Cancel"),
                variant: "outline",
              }}
              rightButtonProps={{
                label: t("conv.delete", "Delete"),
                variant: "warning",
                onClick: async () => {
                  await onDelete();
                  onClose();
                },
              }}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
